// extracted by mini-css-extract-plugin
module.exports = {"container":"hRNBA","dot":"_3tU9m","small":"_33lAq","opacitychange":"_3_6BT"};